<template>
  <div v-if="paymentInfo">
    <el-dialog
      :title="title"
      :visible.sync="payVisible"
      :before-close="onBeforeClose"
      :close-on-click-modal="false"
      :show-close="false"
    >
      <confirm-payment
        v-if="!resultPay"
        :amount="amount"
        :balance="balance"
        :manager="paymentInfo.manager"
        :payment-authority="paymentInfo.paymentAuthority"
        :business-name="paymentInfo.businessName"
        :business-managers="paymentInfo.businessManager"
        :is-business-user="paymentInfo.businessUser"
        :is-show-cancel-btn="true"
        @cancel="onClickCancel"
        @confirm="onClickConfirm"
        @recharge="onClickRecharge"
      >
        <template v-slot:pay-content>
          <div class="envelopes-info-wrapper bg-gray-200 py-5 px-10">
            <div class="envelopes-info-line">
              <span class="ein">交易流水号：</span>
              <span class="eil">{{ paymentInfo.orderNo }}</span>
            </div>
            <div class="envelopes-info-line">
              <span class="ein">交易明细：</span>
              <span class="eil">代理劳务费结算</span>
            </div>
            <div class="envelopes-info-line">
              <span class="ein">支付金额（元）：</span>
              <span class="eil">{{ amount.toFixed(2) }}</span>
            </div>
            <div class="envelopes-info-line" v-if="charge < 1 && balance < amount">
              <span class="text-red text-xs"> (最小充值金额1元，不足1元时按1元充值) </span>
            </div>
          </div>
        </template>
      </confirm-payment>
      <result-payment v-else @success="onClickSuccess" @error="onClickError" />
    </el-dialog>
  </div>
</template>

<script>
import ConfirmPayment from '@/components/pay/components/ConfirmPayment'
import { getSettlementPay } from '@/api/pay/settlement'
import { transformLoadingFunction } from '@/assets/js/el-loading'
import rechargeMixins from '@/mixins/recharge-mixins'
import ResultPayment from '@/components/envelopes/resultPayment/result-payment'
import { getRechargeResult, setPayFlag } from '@/assets/js/pay'

export default {
  name: 'payIndex',
  mixins: [rechargeMixins],
  components: { ConfirmPayment, ResultPayment },
  props: {
    title: {
      type: String,
      default: ''
    },
    visible: {
      type: Boolean,
      default: ''
    },
    surveyId: {
      type: String,
      default: ''
    },
    payInfo: [Array, Object]
  },
  data() {
    return {
      paymentInfo: null,
      resultPay: false,
      isPaymentSuccess: false
    }
  },
  methods: {
    onClickConfirm() {},
    onClickRecharge() {
      this.chargeHandler(this.paymentInfo, () => {
        this.resultPay = true
      })
    },
    onClickCancel() {
      this.payVisible = false
      this.onBeforeClose()
    },
    getPay() {
      let params = this.createParamPay()
      transformLoadingFunction(
        '正在获取信息',
        getSettlementPay(params).then(res => {
          this.paymentInfo = res.data.data
        })
      )
    },
    createParamPay() {
      let payInfos = []
      if (!Array.isArray(this.payInfo)) {
        payInfos = [this.payInfo]
      } else {
        payInfos = this.payInfo
      }
      let result = {
        settleType: '',
        surveyId: this.surveyId,
        payType: 1,
        statementIds: []
      }
      result.statementIds = payInfos.map(item => item.id)
      result.settleType = this.payInfo.settleType

      return result
    },
    onBeforeClose(done) {
      this.paymentInfo = null
      done && done()
    },
    rechargeSuccess() {
      this.isPaymentSuccess = true
      this.$message.success('充值成功')
    },
    handelPaymentError() {
      this.onClickError()
    },
    onClickSuccess() {
      let load = transformLoadingFunction('正在查询充值结果')
      setTimeout(() => {
        if (!this.isPaymentSuccess) {
          this.$message.error('您未支付成功')
          load.close()
          getRechargeResult.flag = false
          setPayFlag(false)
          this.resultPay = false
        }
      }, 5000)
    },
    onClickError() {
      this.$message.error('您未支付成功')
      getRechargeResult.flag = false
      setPayFlag(false)
      this.resultPay = false
    }
  },
  computed: {
    balance() {
      return this.paymentInfo?.balance || 0
    },
    amount() {
      return parseFloat(this.paymentInfo?.amount || 0)
    },
    charge() {
      return parseFloat(this.paymentInfo?.charge || 0)
    },
    payVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  watch: {
    payVisible(v) {
      if (v) {
        this.getPay()
      }
    }
  }
}
</script>

<style scoped lang="scss">
.envelopes-info-line {
  font-size: 14px;
  line-height: 36px;

  .ein {
    color: #555555;
  }

  .eil {
    color: #1a1a1a;
  }
}
</style>
